// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"bbe3992d77b22c415d96","655":"8b7db697f9d08aa17b32"}[chunkId] + ".js";
};